// app/features/industry-opportunities/components/OpportunityApplicabilitySectionComponent.tsx
'use client';

import { Users } from 'lucide-react';

import type { IndustryOpportunity } from '../industry-opportunity.interface';

interface OpportunityApplicabilitySectionComponentProps {
  opportunity: IndustryOpportunity;
}

// True black pills for all categories
const PILL_COLOR = 'bg-black text-white';

export function OpportunityApplicabilitySectionComponent({ 
  opportunity 
}: OpportunityApplicabilitySectionComponentProps) {
  const hasSubVerticals = opportunity.applicable_sub_verticals && opportunity.applicable_sub_verticals.length > 0;
  
  if (!hasSubVerticals) {
    return null;
  }

  return (
    <div className="py-6 lg:py-8 bg-beige-light">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-wrap items-center gap-4 md:gap-6">
          <div className="flex items-center gap-2 text-gray-700">
            <Users size={18} />
            <span className="text-sm font-medium uppercase tracking-wide">Best Fit</span>
          </div>

          <div className="flex flex-wrap items-center gap-3">
            {opportunity.applicable_sub_verticals.map((vertical, index) => (
              <span 
                key={index}
                className={`${PILL_COLOR} text-sm font-medium py-1.5 px-4 rounded-full`}
              >
                {vertical}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

